import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import NProgress from 'nprogress'
import PortalVue from 'portal-vue'

Vue.use(Router)
Vue.use(PortalVue)

const mode = 'history'

const router = new Router({
  mode,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((routeTo, routeFrom, next) => {
  const loggedIn = JSON.parse(localStorage.getItem('auth-data'))
  const isLoggedIn = (loggedIn && loggedIn.refreshToken) || false
  const hasRequiresAuthMeta = routeTo.matched.some(
    record => record.meta.requiresAuth
  )
  if (hasRequiresAuthMeta && !isLoggedIn) {
    NProgress.done()
    // If auth is required and the user is NOT currently logged in,
    // redirect to login then pass the original route to the login component
    return next({ name: 'login', query: { redirect: routeTo.fullPath } })
  }
  if (!hasRequiresAuthMeta && isLoggedIn) {
    NProgress.done()
    return next({ name: 'home' })
  }
  NProgress.start()
  next()
})

router.afterEach(() => NProgress.done())

export default router
